import { render, staticRenderFns } from "./public-red-chirp-provide-secret.vue?vue&type=template&id=18e5875b&scoped=true&"
import script from "./public-red-chirp-provide-secret.vue?vue&type=script&lang=js&"
export * from "./public-red-chirp-provide-secret.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e5875b",
  null
  
)

export default component.exports